import React from 'react';
import { Example1, Example2, Example3 } from './examples';

export const ProblemExamples: React.FC = () => {
  return (
    <div className="examples">
      <Example1 />
      <Example2 />
      <Example3 />
    </div>
  );
}; 